module.exports = __webpack_public_path__ + "static/destek-1232f2deeb7642829f182f9fed1f78e8.svg";